import { Box } from "@mui/material";
import AttorneyForm from "../../attorney/AttorneyForm";

export default function AttorneyTab({
  projectData,
  isDisabled,
  setDisabled,
  initializeLoadingToast,
  updateLoadingToast,
  attorneyController,
  addressController,
  isAttorneySending,
  handleSendAttorney,
  updateProjectAddress,
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <AttorneyForm
        initializeLoadingToast={initializeLoadingToast}
        updateLoadingToast={updateLoadingToast}
        projectId={projectData.id}
        setDisabled={setDisabled}
        isDisabled={isDisabled}
        controller={attorneyController}
        addressController={addressController}
        isEditing={true}
        isAttorneySending={isAttorneySending}
        handleSendAttorney={handleSendAttorney}
        reloadProject={updateProjectAddress}
      />
    </Box>
  );
}
